var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "v-btn",
            { attrs: { color: "success" }, on: { click: _vm.exportExcel } },
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-file-excel")]),
              _vm._v(" Export Excel\n        "),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-textarea", {
        attrs: {
          autofocus: "",
          label: "hãy dùng máy quét",
          rows: "20",
          type: "search",
          enterkeyhint: "done",
        },
        model: {
          value: _vm.vText,
          callback: function ($$v) {
            _vm.vText = $$v
          },
          expression: "vText",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/tool/stock/tool.stock.scan.vue